/*
 * Ventana «Personalizar producto» de Promoregalo: técnicas en tarjetas con icono, nombre claro, para qué sirve, medidas
 * y precio orientativo del marcaje; los colores, en botones. Por dentro mandan los desplegables de siempre
 * (.calc-technique y .calc-colors, ocultos): las tarjetas solo los cambian. El precio sale del mismo PriceCalculator
 * que el presupuesto (window.calcUI), con 1 color y las unidades elegidas.
 * También la foto de cada zona en grande: al pasar el ratón, al lado; al pulsarla (o tocarla en el móvil), encima.
 * Es la calculadora de Markegifts (calculadora-tecnicas.js y calculadora-aspecto.js) llevada a la de Promoregalo.
 */
(() => {
  const modal = document.getElementById('calc-modal-overlay');
  const lista = modal && modal.querySelector('.calc-areas-list');
  if (!modal || !lista || modal.dataset.tarjetas) return;
  modal.dataset.tarjetas = '1';

  const svg = (d) =>
    `<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${d}</svg>`;
  const ICONOS = {
    serigrafia: svg('<rect x="3" y="4" width="18" height="12" rx="2"/><path d="M7 8h10M7 11.5h6"/><path d="M5 20h14M9 16v4M15 16v4"/>'),
    tampografia: svg('<path d="M9 3h6v4a3 3 0 0 0 3 3v3H6v-3a3 3 0 0 0 3-3z"/><path d="M5 16h14v4H5z"/>'),
    dtf: svg('<rect x="4" y="3" width="12" height="16" rx="2"/><circle cx="10" cy="9" r="2.5"/><path d="M7 15h6"/><path d="M19 7v11a3 3 0 0 1-3 3H8"/>'),
    transfer: svg('<path d="M4 15h16l-2.5-7H9a5 5 0 0 0-5 5z"/><path d="M9 8V5h7"/><path d="M6 19.5c1.2-1 2.4 1 3.6 0s2.4 1 3.6 0 2.4 1 3.6 0"/>'),
    laser: svg('<path d="M9 3h6v6l-3 3-3-3z"/><path d="M12 12v4"/><path d="M8.5 17.5L12 16l3.5 1.5"/><path d="M4 21h16"/>'),
    digital: svg('<path d="M7 8V3h10v5"/><rect x="3" y="8" width="18" height="8" rx="2"/><path d="M7 13h10v8H7z"/>'),
    sublimacion: svg('<path d="M12 3s5 5.5 5 9a5 5 0 0 1-10 0c0-3.5 5-9 5-9z"/><path d="M3 21c1.5-1.2 3 1.2 4.5 0s3 1.2 4.5 0 3 1.2 4.5 0 3 1.2 4.5 0"/>'),
    termograbado: svg('<path d="M12 3c2 2.5 4 4 4 7a4 4 0 0 1-8 0c0-1.8 1-3 2-4 0 1.6.8 2.6 2 2.6 0-2-1-3.6 0-5.6z"/><path d="M4 20h16"/>'),
    resina: svg('<path d="M4 17a8 8 0 0 1 16 0z"/><path d="M3 17h18"/><path d="M9 12.5a3.5 3.5 0 0 1 3-2.5"/>'),
    etiqueta: svg('<path d="M3 12V4h8l10 10-8 8z"/><circle cx="7.5" cy="8.5" r="1.5"/>'),
    bordado: svg('<path d="M20 4L9.5 14.5"/><path d="M17.5 3l3.5 3.5"/><path d="M9.5 14.5c-3 1-5 3-4 5s4.2 0 5-3"/>'),
    otra: svg('<path d="M4 20c2.5 0 4.5-1.2 4.5-3.5 0-1.2-1-2-1-2L17 5l3 3-9.5 9.5"/>'),
  };
  // El orden importa: DTF antes que transfer, termograbado antes que láser, etiqueta antes que digital.
  // todoColor: a todo color aunque el proveedor diga «1 color»
  const FAMILIAS = [
    { re: /dtf/i, nombre: 'DTF', frase: 'Se imprime en un film y se fija con calor. A todo color: fotos, degradados y detalles finos.', icono: 'dtf', todoColor: true },
    { re: /transfer.*digital/i, nombre: 'Transfer digital', frase: 'A todo color, impreso en lámina y fijado con calor.', icono: 'transfer', todoColor: true },
    { re: /transfer.*serigr/i, nombre: 'Transfer serigráfico', frase: 'Colores planos impresos en lámina y fijados con calor.', icono: 'transfer' },
    { re: /transfer.*reflect/i, nombre: 'Transfer reflectante', frase: 'Lámina que refleja la luz, fijada con calor. Muy visible de noche.', icono: 'transfer' },
    { re: /serigraf.*circular/i, nombre: 'Serigrafía circular', frase: 'Serigrafía que rodea piezas cilíndricas, como vasos o botellas.', icono: 'serigrafia' },
    { re: /serigraf/i, nombre: 'Serigrafía', frase: 'Tinta directa. Ideal para logos de pocos colores y muchas unidades.', icono: 'serigrafia' },
    { re: /tampograf/i, nombre: 'Tampografía', frase: 'Para piezas pequeñas o curvas, como bolígrafos o llaveros.', icono: 'tampografia' },
    { re: /termo\s*grabad/i, nombre: 'Termograbado', frase: 'Marcado con calor y presión, en bajorrelieve. Muy elegante.', icono: 'termograbado' },
    { re: /360.*l[aá]ser|l[aá]ser.*360/i, nombre: 'Grabado láser 360°', frase: 'Grabado permanente que rodea toda la pieza.', icono: 'laser' },
    { re: /retroilumin/i, nombre: 'Láser retroiluminado', frase: 'Grabado que deja pasar la luz del producto.', icono: 'laser' },
    { re: /l[aá]ser|grabado/i, nombre: 'Grabado láser', frase: 'Grabado permanente sin tinta, sobre metal, madera o cristal.', icono: 'laser' },
    { re: /sublimaci/i, nombre: 'Sublimación', frase: 'La tinta se funde con el material. Todo color sobre fondos claros.', icono: 'sublimacion' },
    { re: /etiqueta/i, nombre: 'Etiqueta adhesiva', frase: 'Adhesivo impreso a todo color.', icono: 'etiqueta' },
    { re: /transfer/i, nombre: 'Transfer', frase: 'Diseño impreso en lámina y fijado con calor. Admite varios colores.', icono: 'transfer', fraseSegunColores: true },
    { re: /resina|doming|gota/i, nombre: 'Resina', frase: 'Etiqueta a todo color con relieve de resina transparente.', icono: 'resina' },
    { re: /digital.*360|360.*digital/i, nombre: 'Impresión digital 360°', frase: 'A todo color, alrededor de toda la pieza.', icono: 'digital' },
    { re: /digital|uv|impresi|^full\s*colou?r$/i, nombre: 'Impresión digital', frase: 'A todo color, también fotos y degradados.', icono: 'digital', todoColor: true },
    { re: /bordad/i, nombre: 'Bordado', frase: 'Hilo cosido: acabado premium y muy duradero.', icono: 'bordado' },
  ];
  const familiaDe = (nombre) =>
    FAMILIAS.find((f) => f.re.test(nombre || '')) || { nombre: String(nombre || '').trim(), frase: '', icono: 'otra' };

  const escapa = (v) => String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const euros = (n) => `${n.toFixed(2).replace('.', ',')} €`;
  // Medidas: marcaje_json de Makito en cm y el resto en mm; aquí todo en mm, como la cuenta
  const mm = (v) => (typeof marcajeDimToMm === 'function' ? marcajeDimToMm(v, window.productVendor) : Number(v) || 0);
  const cm = (v) => String(Math.round(Number(mm(v))) / 10).replace('.', ',');
  const tecnicaDe = (item, valor) => (window.areasData?.[item.dataset.index]?.tecnicas || [])[parseInt(valor, 10)];

  function datosDe(t) {
    const max = parseInt(t.colores_max, 10);
    const colores = !familiaDe(t.nombre).todoColor && !isNaN(max) && max > 0 ? `Hasta ${max} color${max > 1 ? 'es' : ''}` : 'Todo color';
    const ancho = mm(t.ancho);
    const alto = mm(t.alto);
    return ancho && alto ? `${colores}. Hasta ${ancho} × ${alto} mm` : colores;
  }

  // «Marcaje desde X €/u»: con 1 color, las unidades elegidas y la medida del diseño si el cliente la ha dicho
  function precioDe(t, item) {
    const ui = window.calcUI;
    if (!ui) return '';
    try {
      const uds = ui.getCurrentQuantity();
      let ancho = mm(t.ancho);
      let alto = mm(t.alto);
      const disenoAncho = Number(item.dataset.disenoAncho);
      const disenoAlto = Number(item.dataset.disenoAlto);
      if (disenoAncho > 0 && disenoAlto > 0 && typeof medidaDentro === 'function') [ancho, alto] = medidaDentro(disenoAncho, disenoAlto, ancho, alto);
      const c = ui.calculator.calculateAreaCost(t.code_tec_ref || t.ref, uds, 1, ancho, alto, false);
      const porUnidad = c.totalArea / uds;
      return !c.error && Number.isFinite(porUnidad) && porUnidad > 0 ? `Marcaje desde ${euros(porUnidad)}/u` : '';
    } catch (e) {
      return '';
    }
  }

  function pintar(item) {
    const sel = item && item.querySelector('.calc-technique');
    const colSel = item && item.querySelector('.calc-colors');
    const caja = item && item.querySelector('.mk-tecnicas-caja');
    if (!sel || !colSel || !caja) return;

    // Algunos proveedores repiten la misma técnica idéntica varias veces: una sola tarjeta por técnica
    const clave = (t) => (t ? [t.nombre, t.colores_max, t.ancho, t.alto, t.code_tec_ref].join('|') : '');
    const opciones = [...sel.options].filter((o) => o.value !== '');
    const primera = {};
    opciones.forEach((o) => {
      const k = clave(tecnicaDe(item, o.value));
      if (!(k in primera)) primera[k] = o.value;
    });
    const unicas = opciones.filter((o) => primera[clave(tecnicaDe(item, o.value))] === o.value);
    const elegida = sel.value === '' ? '' : primera[clave(tecnicaDe(item, sel.value))] ?? sel.value;
    const tecnicas = unicas.map((o) => tecnicaDe(item, o.value));
    const familias = tecnicas.map((t, k) => familiaDe(t?.nombre || unicas[k].textContent));
    // Si una zona tiene varias de la misma familia, se distinguen por sus colores; si no, por su tamaño
    const porColores = (t, f) => {
      const max = parseInt(t.colores_max, 10);
      return !isNaN(max) && max > 0 ? `${f.nombre} hasta ${max} color${max > 1 ? 'es' : ''}` : `${f.nombre} a todo color`;
    };
    const nombres = tecnicas.map((t, k) => {
      const f = familias[k];
      const hermanas = tecnicas.filter((u, j) => u && familias[j].nombre === f.nombre);
      // El DTF se cobra por superficie: siempre con su tamaño, aunque solo haya uno
      if (t && f.icono === 'dtf' && Number(t.ancho) > 0 && Number(t.alto) > 0) return `${f.nombre} hasta ${cm(t.ancho)} × ${cm(t.alto)} cm`;
      if (!t || hermanas.length < 2) return f.nombre;
      if (new Set(hermanas.map((u) => String(u.colores_max))).size > 1) return porColores(t, f);
      if (new Set(hermanas.map((u) => `${u.ancho}x${u.alto}`)).size > 1) return `${f.nombre} hasta ${cm(t.ancho)} × ${cm(t.alto)} cm`;
      return porColores(t, f);
    });
    const tarjetas = unicas.map((o, k) => {
      const t = tecnicas[k];
      if (!t) return '';
      const f = familias[k];
      const maxColores = parseInt(t.colores_max, 10);
      const frase = !f.fraseSegunColores ? f.frase
        : !isNaN(maxColores) && maxColores > 0 ? 'Colores planos impresos en lámina y fijados con calor.' : 'A todo color, impreso en lámina y fijado con calor.';
      // Mismo nombre aún: el código del proveedor («[N4]», «(A)»)
      const codigo = (String(t.nombre).match(/\[([^\]]+)\]|\(([A-Z0-9*]{1,4})\)/) || []).slice(1).find(Boolean);
      const nombre = nombres.filter((n) => n === nombres[k]).length > 1 && codigo ? `${nombres[k]} (${codigo})` : nombres[k];
      return `<button type="button" class="mk-tecnica" role="radio" aria-checked="${o.value === elegida}" data-valor="${o.value}">
        <span class="mk-tecnica__icono">${ICONOS[f.icono]}</span>
        <span class="mk-tecnica__nombre">${escapa(nombre)}</span>
        ${frase ? `<span class="mk-tecnica__frase">${frase}</span>` : ''}
        <span class="mk-tecnica__datos">${datosDe(t)}</span>
        <span class="mk-tecnica__precio" data-precio>${precioDe(t, item)}</span>
      </button>`;
    });
    const colores = colSel.disabled ? [] : [...colSel.options].filter((o) => o.value !== '').map((o) => {
      const texto = /full/i.test(o.value) ? 'Todo color' : o.value;
      return `<button type="button" class="mk-color${/^\d+$/.test(texto) ? ' mk-color--num' : ''}" role="radio" aria-checked="${o.value === colSel.value}" data-valor="${escapa(o.value)}">${escapa(texto)}</button>`;
    });

    caja.innerHTML = `
      <p class="mk-tecnicas__titulo">${elegida === '' ? 'Elige la técnica' : 'Técnica'}</p>
      <div class="mk-tecnicas" role="radiogroup" aria-label="Técnica">${tarjetas.join('')}</div>
      ${
        colores.length > 1
          ? `<p class="mk-tecnicas__titulo">Colores de tu diseño</p>
      <div class="mk-colores" role="radiogroup" aria-label="Colores de tu diseño">${colores.join('')}</div>`
          : ''
      }`;
  }

  function preciosAlDia() {
    lista.querySelectorAll('.calc-accordion-item').forEach((item) => {
      item.querySelectorAll('.mk-tecnica').forEach((b) => {
        const t = tecnicaDe(item, b.dataset.valor);
        const hueco = b.querySelector('[data-precio]');
        const texto = t ? precioDe(t, item) : '';
        if (hueco && hueco.textContent !== texto) hueco.textContent = texto;
      });
    });
  }

  lista.addEventListener('click', (e) => {
    const tarjeta = e.target.closest('.mk-tecnica');
    const color = e.target.closest('.mk-color');
    if (!tarjeta && !color) return;
    const item = e.target.closest('.calc-accordion-item');
    if (tarjeta) {
      // Elegir técnica en una zona sin marcar la marca: si no, no entraría en el presupuesto
      const chk = item.querySelector('.calc-area-checkbox');
      if (chk && !chk.checked) chk.checked = true;
      const sel = item.querySelector('.calc-technique');
      sel.value = tarjeta.dataset.valor;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      const colSel = item.querySelector('.calc-colors');
      colSel.value = color.dataset.valor;
      colSel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    pintar(item);
  });

  // La calculadora pinta las zonas al cargar los precios y rehace los colores al cambiar de técnica
  lista.addEventListener('change', (e) => {
    if (e.target.matches('.calc-technique, .calc-colors')) pintar(e.target.closest('.calc-accordion-item'));
  });
  const pintarTodas = () => lista.querySelectorAll('.calc-accordion-item').forEach(pintar);
  new MutationObserver(pintarTodas).observe(lista, { childList: true });
  pintarTodas();
  const total = document.getElementById('calc-final-total');
  if (total) new MutationObserver(preciosAlDia).observe(total, { childList: true, characterData: true, subtree: true });

  /* ---------- La foto de la zona en grande ---------- */
  const conRaton = window.matchMedia('(hover: hover) and (pointer: fine)');
  const nombreDe = (img) => img.closest('.calc-accordion-header')?.querySelector('.mk-area__nombre')?.textContent.trim() || '';

  const vista = document.createElement('div');
  vista.className = 'mk-zoom';
  vista.setAttribute('aria-hidden', 'true');
  vista.innerHTML = '<img alt=""><span></span>';
  modal.appendChild(vista);
  const mostrar = (img) => {
    if (!conRaton.matches) return;
    vista.querySelector('img').src = img.currentSrc || img.src;
    vista.querySelector('span').textContent = nombreDe(img);
    const r = img.getBoundingClientRect();
    const ancho = 300;
    const alto = 340;
    const izquierda = r.right + 14 + ancho < window.innerWidth ? r.right + 14 : Math.max(8, r.left - 14 - ancho);
    const arriba = Math.min(Math.max(8, r.top + r.height / 2 - alto / 2), window.innerHeight - alto - 8);
    vista.style.left = `${izquierda}px`;
    vista.style.top = `${arriba}px`;
    vista.classList.add('is-visible');
  };
  const ocultar = () => vista.classList.remove('is-visible');
  modal.addEventListener('mouseover', (e) => {
    if (e.target.matches('.mk-area__img')) mostrar(e.target);
  });
  modal.addEventListener('mouseout', (e) => {
    if (e.target.matches('.mk-area__img')) ocultar();
  });
  modal.addEventListener('scroll', ocultar, true);

  const lupa = document.createElement('div');
  lupa.className = 'mk-lupa';
  lupa.setAttribute('role', 'dialog');
  lupa.setAttribute('aria-modal', 'true');
  lupa.setAttribute('aria-label', 'Zona de marcaje en grande');
  lupa.hidden = true;
  lupa.innerHTML = '<figure class="mk-lupa__caja"><button type="button" class="mk-lupa__cerrar" aria-label="Cerrar"><svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button><img alt=""><figcaption></figcaption></figure>';
  modal.appendChild(lupa);
  const cerrarLupa = () => {
    lupa.hidden = true;
  };
  modal.addEventListener('click', (e) => {
    if (!(e.target instanceof Element)) return;
    if (e.target.matches('.mk-area__img')) {
      // La calculadora no abre ni marca la zona al pulsar la miniatura (bindEvents la ignora)
      ocultar();
      const foto = lupa.querySelector('img');
      foto.src = e.target.currentSrc || e.target.src;
      const nombre = nombreDe(e.target);
      foto.alt = nombre ? `Zona de marcaje: ${nombre}` : 'Zona de marcaje';
      lupa.querySelector('figcaption').textContent = nombre;
      lupa.hidden = false;
      lupa.querySelector('.mk-lupa__cerrar').focus();
      return;
    }
    if (e.target === lupa || e.target.closest('.mk-lupa__cerrar')) {
      // Cerrar la foto no cierra la ventana de personalizar
      e.stopPropagation();
      cerrarLupa();
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !lupa.hidden) cerrarLupa();
  });
})();
